import FellohLogo from "../../images/logo-dark2x.png";
import AcquirerFlowLogo from "../../images/acquirerflowlogo.png";
import FellohLogoWhite from "../../images/logo-white.png";
import AcquirerFlowLogoWhite from "../../images/logo-af-white.png";

const domain = () => {
  const isAcquirerFlow = process.env.REACT_APP_SITE === 'acquirerflow';

  return {
    isAcquirerFlow,
    name: isAcquirerFlow ? 'AcquirerFlow' : 'Felloh',
    styles: {
      primaryColour: isAcquirerFlow ? 'bg-blue-600' : 'bg-violet-800',
      primaryColourDarker: isAcquirerFlow ? 'bg-blue-900' : 'bg-violet-900',
      textColour: isAcquirerFlow ? 'text-blue-900' : 'text-violet-900',
      borderColour: isAcquirerFlow ? 'border-blue-800' : 'border-violet-800',
      borderColourHex: isAcquirerFlow ? '#1e3a8a' : '#581c87',
      lightBorderColour: isAcquirerFlow ? 'border-blue-200' : 'border-violet-200',
      darkBorderColour: isAcquirerFlow ? 'border-blue-800' : 'border-violet-800',
      lightBGColour: isAcquirerFlow ? 'bg-blue-50' : 'bg-violet-50',
      buttonColour: isAcquirerFlow 
        ? 'bg-blue-600 hover:bg-blue-700 border-blue-600 hover:border-blue-700 disabled:bg-blue-400 disabled:border-blue-400' 
        : 'bg-violet-800 hover:bg-violet-900 border-violet-800 hover:border-violet-900 disabled:bg-violet-400 disabled:border-violet-400',
    },
    text: {
      helpEmail: isAcquirerFlow ? 'help@acquirerflow.com' : 'help@felloh.com',
      tagline: isAcquirerFlow ? 'Your acquiring just got much smarter' : 'Payments operations for travel',
    },
    logo: isAcquirerFlow ? AcquirerFlowLogo : FellohLogo,
    logoWhite: isAcquirerFlow ? AcquirerFlowLogoWhite : FellohLogoWhite,
  };
};

export default domain;